<template>
  <div
    class="cp-search-select"
    v-if="Object.keys(filterList).length > 0"
  >
    <span
      class="cp-search-select__label"
      @click="test"
    >{{ filterText }}</span>
    <v-select
      @input="change"
      :options="options"
      :clearable="true"
      :searchable="false"
      ref="filterBy"
    >
      <template #open-indicator="{ attributes }">
        <span
          v-bind="attributes"
        ><svg
          id="icon-nav-arrow"
          viewBox="0 0 41 32"
        >
          <path
            d="M2.496 2.903c5.393 8.939 11.35 17.501 17.83 25.63 6.498-8.114 12.455-16.677 17.83-25.63l2.57 1.754c-5.905 9.455-12.288 18.58-19.123 27.337h-2.496c-6.835-8.754-13.213-17.879-19.108-27.337l2.496-1.754z"
          ></path></svg></span>
      </template>
    </v-select>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  components: {
    vSelect,
  },
  props: {
    query: {
      type: [String, Number],
      required: true,
    },
    filterText: {
      type: String,
      required: false,
      default: '',
    },
    filterList: {
      type: [Array, Object],
      required: true,
    },
    baseUrl: {
      type: String,
      required: true,
    },
    filterSelect: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      options: Object.values(this.filterList),
      selected: '',
    };
  },


  watch: {
    filterSelect(newValue) {
      if (newValue === '') {
        this.$refs.filterBy.$refs.clearButton.click();
      }
    },
    filterList: {
      handler(newValue) {
        if (newValue !== '') {
          this.options = Object.values(newValue)
        }
      },
      deep: true,
    },

  },

  methods: {
    /* eslint-disable */

      test() {
          this.$refs.filterBy.$data.open = !this.$refs.filterBy.$data.open
      },
    change(e) {
      const selectedCode = e;
      this.selected = Object.keys(this.filterList).find(
        (key) => this.filterList[key] === selectedCode
      );
      return this.$emit("optionSelected", this.selected);
    },
  },
};
</script>
